import {Form, Input, Select} from 'antd';
import FadeEffect from 'components/animation/fadeEffect';
import plusIcon from 'images/plus-circle.png';
import deleteIcon from 'images/delete.svg';
import {fieldRules} from 'utils/helper';
import styles from '../rewardSchemeTabs/newRewardSchemes.module.scss';
import {walletCurrencies} from 'utils/mock';

export const AllowedCurrenciesSection = ({form}) => {
  const allowedCurrencies = Form.useWatch('allowedCurrencies', form) || [];

  return (
    <>
      <h3 className={styles.title}>Allowed Currencies</h3>
      <Form.List name="allowedCurrencies">
        {(fields, {add, remove}) => (
          <>
            {fields.map(({key, name: fieldName}, index) => (
              <FadeEffect key={key}>
                <div className={styles['key-facts']} key={key}>
                  <div>
                    <Form.Item
                      label="Currency"
                      name={[fieldName, 'currency']}
                      rules={[fieldRules('currency is required')]}>
                      <Select allowClear>
                        {walletCurrencies.map(({key, name}) => (
                          <Select.Option value={key} key={key}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Minimum Transaction Value"
                      name={[fieldName, 'minTransactionValue']}
                      rules={[fieldRules('min transaction value is required')]}>
                      <Input />
                    </Form.Item>
                    {(!allowedCurrencies[index]?.currency ||
                      !allowedCurrencies[index]?.minTransactionValue) && (
                      <span className={styles.warning}>
                        Please note both fields are required
                      </span>
                    )}
                  </div>
                  <img
                    onClick={() => remove(fieldName)}
                    src={deleteIcon}
                    alt=""
                  />
                </div>
              </FadeEffect>
            ))}
            <div
              onClick={() => add({currency: '', minTransactionValue: ''})}
              className={styles['add-button']}>
              <img src={plusIcon} alt="" />
              <h1>Add Currency</h1>
            </div>
          </>
        )}
      </Form.List>
    </>
  );
};
